export const navLinks = [
  { label: '首页', href: '/' },
  { label: '视频分类', href: '/category' },
  { label: '资讯动态', href: '/article' },
  { label: '关于我们', href: '/about' },
];

export const siteInfo = {
  name: '91在线视频',
  slogan: '随时随地，畅享精彩视频内容',
  description: '91在线视频是领先的在线视频内容平台，致力于为用户提供丰富多样的视频资源和流畅的观看体验。我们持续更新平台入口与移动端应用，确保用户随时随地畅享精彩内容。',
  email: 'support@91zaixianshipin.com',
  phone: '400-888-9999',
  address: '中国北京市朝阳区建国路88号',
  icp: '京ICP备2024XXXXXX号',
};

export const quickLinks = [
  { label: '最新地址', href: '/#announcement' },
  { label: 'APP下载', href: '/#download' },
  { label: '热门推荐', href: '/#hot' },
  { label: '帮助中心', href: '/article' },
  { label: '用户协议', href: '/article/user-agreement' },
];

export const categoryList = [
  { label: '热门精选', href: '/category/remen' },
  { label: '最新上线', href: '/category/zuixin' },
  { label: '电影大片', href: '/category/dianying' },
  { label: '电视剧集', href: '/category/dianshiju' },
  { label: '综艺娱乐', href: '/category/zongyi' },
  { label: '动漫动画', href: '/category/dongman' },
  { label: '纪录片', href: '/category/jilupian' },
  { label: '短视频', href: '/category/duanshipin' },
];

export const socialLinks = [
  { label: '微博', href: '#', icon: 'ri-weibo-line' },
  { label: '微信', href: '#', icon: 'ri-wechat-line' },
  { label: 'QQ群', href: '#', icon: 'ri-qq-line' },
];